import {
  Component,
  EventEmitter,
  Input,
  Optional,
  Output,
  ViewChild,
} from '@angular/core'
import { ControlContainer, NgForm, NgModel } from '@angular/forms'
import {
  InputSubmit,
  TrackedBarcodeMode,
} from '@evologi/shared/data-access-api'

@Component({
  selector: 'op-input-text-ng',
  templateUrl: './input-text-ng.component.html',
  styleUrls: ['./input-text-ng.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      deps: [[Optional, NgForm]],
      useFactory: (ngForm: NgForm) => ngForm,
    },
  ],
})
export class InputTextNgComponent {
  @ViewChild('inputModel', { static: true }) inputModel!: NgModel

  @Input()
  type: 'text' | 'email' | 'password' = 'text'
  @Input() placeholder?: string
  @Input() key?: string
  @Input() value: string | undefined | null
  @Input() autocomplete = 'off'
  @Input() textAlign: 'left' | 'center' | 'right' = 'left'
  @Input() fontSize: '1rem' | '3rem' = '1rem'
  @Input() slugify?: string

  // Style
  @Input() clearButton = false
  @Input() disabled = false
  @Input() markIfValid = false

  // Group management
  @Input() group = false
  @Input() preContent = false
  @Input() preLabel?: string
  @Input() postContent = false
  @Input() postLabel?: string

  // Errors
  @Input() required = false
  @Input() requiredError?: string
  @Input() minLength?: number
  @Input() minLengthError?: string

  // Validation
  @Input() validateUnique = false
  @Input() validateField?: string
  @Input() validateElement?: 'supplier' | 'user'
  @Input() validateUniqueError?: string
  @Input() detectSource = false

  // Validate Equal
  @Input() validateEqual?: string // The value to compare against
  @Input() validateEqualError?: string

  // Transformation
  @Input() toLowerCase = false

  public inputClasses = ''

  @Output() readonly valueChange = new EventEmitter<string>()
  @Output() readonly valueSubmit = new EventEmitter<string>()
  @Output() readonly sourceSubmit = new EventEmitter<InputSubmit>()
  @Output() readonly focusOut = new EventEmitter<string>()

  // Validation state properties
  get isValid(): boolean {
    return (
      this.markIfValid && !!(this.inputModel?.valid && this.inputModel?.touched)
    )
  }

  get isInvalid(): boolean {
    return !!(this.inputModel?.invalid && this.inputModel?.touched)
  }

  // Check if values match
  get hasEqualError(): boolean {
    if (!this.validateEqual) return false
    return this.value !== this.validateEqual && !!this.inputModel?.touched
  }

  emitValue(value: string) {
    // Apply toLowerCase transformation if enabled
    const transformedValue = this.toLowerCase ? value.toLowerCase() : value
    this.valueChange.emit(transformedValue)
  }

  clearValue() {
    this.emitValue('')
  }

  onEnter(): void {
    if (this.detectSource) {
      return
    }
    this.valueSubmit.emit(this.value || '')
  }

  onSourceSubmit(event: InputSubmit): void {
    if (!this.detectSource) {
      return
    }
    this.valueChange.emit(event.value)
    this.sourceSubmit.emit(event)
  }

  onSearchClick(mode: TrackedBarcodeMode): void {
    if (this.detectSource) {
      this.onSourceSubmit({ value: this.value || '', mode })
      return
    }
    this.valueSubmit.emit(this.value || '')
  }
}
